@if (formField(); as field) {
  <app-file-uploader
    [label]="field.label"
    [required]="field.required ? 'true' : 'false'"
    [maxlength]="field.maxlength!"
    [accept]="field.accept"
    [minlength]="field.minlength!"
    [uploadHandler]="field.uploadHandler"
    [deleteHandler]="field.deleteHandler"
    [(value)]="value"
  />
}
